import React, { useState, useRef } from 'react';

// --- STYLES ---
const styles = {
  container: {
    position: 'relative',
    width: '100%',
    height: '90vh', // Or whatever height you want
    overflow: 'hidden',
    cursor: 'none', 
    backgroundColor: '#000',
  },
  layer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    // REMOVE flexbox alignment. We don't need it because the image 
    // already contains the positioning data (the transparent pixels).
    pointerEvents: 'none',
  },
  // NOW: Both Background and Characters use the EXACT same style
  backgroundImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover', // Fill the container
    objectPosition: 'center', // Align to center
  },
  characterImg: {
    width: '100%',      // Match background width
    height: '100%',     // Match background height
    objectFit: 'cover', // Match background scaling
    objectPosition: 'center', // Match background alignment
    pointerEvents: 'none',
  },
  imageStyle: {
    position: 'absolute', // <--- THIS IS THE KEY FIX
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',    // Ensures they scale together
    objectPosition: 'center', 
    pointerEvents: 'none',
  },
  // The Green Scope Ring
  scope: {
    position: 'absolute',
    width: '300px', // Match mask size
    height: '300px',
    border: '2px solid #00ff00', // Toxic Green
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)', // Centers div on mouse
    pointerEvents: 'none',
    boxShadow: '0 0 15px #00ff00, inset 0 0 10px #00ff00', // Glowing effect
    zIndex: 50,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // Crosshair inside scope
  crosshair: {
    width: '10px',
    height: '10px',
    border: '1px solid rgba(0, 255, 0, 0.5)',
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 255, 0, 0.2)',
  },
  // --- NEW LOGO STYLES ---
  logoWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',    // Centers vertically
    justifyContent: 'center', // Centers horizontally (putting it right between the girls)
    pointerEvents: 'none',   // CRITICAL: Lets the mouse track through the logo
    zIndex: 20,              // Puts it above the characters, but below the scope (which is 50)
  },
  logoImgStyle: {
    maxWidth: '500px', // Adjust depending on your logo size
    width: '100%',
    height: 'auto',
    filter: 'drop-shadow(0 4px 15px rgba(0,0,0,0.5))', // Adds a nice shadow to separate it from the background
    transform: 'translate(100px, -50px)',
  },
};

const XRayHero = ({ 
  bgImage, 
  clothedImage, 
  secretImage,
  logoImage
}) => {
  const [cursorPos, setCursorPos] = useState({ x: -100, y: -100 });
  const containerRef = useRef(null);

  // TRACK MOUSE
  const handleMouseMove = (e) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    setCursorPos({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    });
  };

  // THE MASK LOGIC
  const maskStyle = {
    // Reveal Layer 1 (Bottom) wherever the mouse is
    maskImage: `radial-gradient(circle 150px at ${cursorPos.x}px ${cursorPos.y}px, transparent 100%, black 100%)`,
    WebkitMaskImage: `radial-gradient(circle 150px at ${cursorPos.x}px ${cursorPos.y}px, transparent 100%, black 100%)`,
  };

  return (
    <div 
      style={styles.container} 
      onMouseMove={handleMouseMove} 
      ref={containerRef}
    >
      {/* --- LAYER 1: SECRET (BOTTOM) --- */}
      <div style={styles.layer}>
        {/* Background */}
        {bgImage && <img src={bgImage} style={styles.imageStyle} alt="" />} 
        
        {/* Character (Secret) */}
        {secretImage && <img src={secretImage} style={styles.imageStyle} alt="Secret" />}
      </div>

      {/* --- LAYER 2: PUBLIC (TOP) --- */}
      <div style={{ ...styles.layer, ...maskStyle }}>
        {/* Background */}
        {bgImage && <img src={bgImage} style={styles.imageStyle} alt="" />}
        
        {/* Character (Clothed) */}
        {clothedImage && <img src={clothedImage} style={styles.imageStyle} alt="Public" />}
      </div>

      {/* --- LAYER 3: THE LOGO OVERLAY --- */}
      {logoImage && (
        <div style={styles.logoWrapper}>
          <img src={logoImage} style={styles.logoImgStyle} alt="3XRay Logo" />
        </div>
      )}

      {/* --- THE SCOPE CURSOR --- */}
      <div style={{ ...styles.scope, left: cursorPos.x, top: cursorPos.y }}>
        <div style={styles.crosshair} />
      </div>

    </div>
  );
};

export default XRayHero;